import { buildStyleFns, buildStylePropFn } from './buildStyleFns';
export var colorStyleFnConfigs = [
    {
        name: 'backgroundColor',
        properties: ['backgroundColor'],
        system: 'color',
    },
    {
        name: 'color',
        properties: ['color'],
        system: 'color',
    },
    {
        name: 'opacity',
        properties: ['opacity'],
        system: 'none',
    },
];
export var colorFns = buildStyleFns(colorStyleFnConfigs);
/**
 * A style prop function that takes component props and returns color styles from Canvas token values.
 * If no `ColorStyleProps` are found, it returns an empty object.
 *
 * @example
 * ```tsx
 * const BoxExample = () => (
 *   <Box color="frenchVanilla100" opacity={0.6}>Hello, colors!</Box>
 * );
 * ```
 */
export var color = buildStylePropFn(colorFns);
